"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkProperties = void 0;
const check_1 = require("../check");
const ctx_1 = require("../ctx");
const equivalent_1 = require("../equivalent");
const Errors = __importStar(require("../errors"));
const evaluate_1 = require("../evaluate");
const Values = __importStar(require("../value"));
function checkProperties(mod, ctx, properties, clazz) {
    switch (clazz["@kind"]) {
        case "ClazzNull": {
            return {};
        }
        case "ClazzCons": {
            const property = properties[clazz.propertyName];
            if (property === undefined) {
                throw new Errors.ElaborationError(`[checkProperties] missing property: ${clazz.propertyName}`, {});
            }
            const propertyCore = (0, check_1.check)(mod, ctx, property, clazz.propertyType);
            const propertyValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), propertyCore);
            ctx = (0, ctx_1.CtxFulfilled)(clazz.propertyName, clazz.propertyType, propertyValue, ctx);
            const rest = Values.clazzClosureApply(clazz.restClosure, propertyValue);
            return Object.assign({ [clazz.propertyName]: propertyCore }, checkProperties(mod, ctx, properties, rest));
        }
        case "ClazzFulfilled": {
            const property = properties[clazz.propertyName];
            if (property === undefined) {
                throw new Errors.ElaborationError(`[checkProperties] missing property: ${clazz.propertyName}`, {});
            }
            const propertyCore = (0, check_1.check)(mod, ctx, property, clazz.propertyType);
            const propertyValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), propertyCore);
            (0, equivalent_1.equivalent)(mod, ctx, clazz.propertyType, propertyValue, clazz.property);
            ctx = (0, ctx_1.CtxFulfilled)(clazz.propertyName, clazz.propertyType, propertyValue, ctx);
            return Object.assign({ [clazz.propertyName]: propertyCore }, checkProperties(mod, ctx, properties, clazz.rest));
        }
    }
}
exports.checkProperties = checkProperties;
//# sourceMappingURL=checkProperties.js.map